import Immutable from 'immutable';
import {
  CREATE_GROUP,
  UPDATE_GROUP,
  SET_GROUPS,
  REMOVE_GROUP,
  UPDATE_GROUP_ADMIN_ACCESS,
  FETCH_COHORT_GROUPS_LISTING_DATA_SUCCESS,
  FETCH_COHORT_GROUPS_LISTING_DATA_START,
  FETCH_COHORT_GROUPS_LISTING_DATA_FAILURE,
} from './actions';

import { ActionTypes as GalleryActionTypes } from '../Galleries/actions';
import { BLOCKPAGE_DATA_LOADED_SUCCESS } from '../BlockPageUI/actions';
import { ActionTypes as PageActionTypes } from '../Pages/actions';

const initialState = Immutable.fromJS({
  byPath: {},
  byCohortPath: {},
});

export function Groups(state = initialState, action) {
  const setGroups = (groups, _state) => {
    let newState = _state;
    groups.forEach((group) => {
      newState = newState.updateIn(
        ['byPath', group.get('path')],
        Immutable.Map(),
        (g) => g.merge(group)
      );
    });
    return newState;
  };

  switch (action.type) {
    case UPDATE_GROUP: {
      const { path, changes } = action;
      return state.updateIn(['byPath', path], Immutable.Map(), (g) =>
        g.merge(Immutable.fromJS(changes))
      );
    }
    case CREATE_GROUP: {
      const { group } = action;
      return state.setIn(['byPath', group.get('path')], group);
    }
    case GalleryActionTypes.PORTFOLIO_QUERY_COMPLETE:
    case SET_GROUPS: {
      return setGroups(action.groups, state);
    }

    case UPDATE_GROUP_ADMIN_ACCESS: {
      const { path, userId, isAdmin } = action;

      return state.updateIn(['byPath', path, 'members'], (members) => {
        return members.map((member) => {
          return member.get('user') === userId
            ? member.set('admin', isAdmin)
            : member;
        });
      });
    }
    case REMOVE_GROUP: {
      return state.deleteIn(['byPath', action.path]);
    }
    case FETCH_COHORT_GROUPS_LISTING_DATA_START: {
      return state.setIn(
        ['byCohortPath', action.cohortPath, 'isLoading'],
        true
      );
    }
    case FETCH_COHORT_GROUPS_LISTING_DATA_SUCCESS: {
      let newState = setGroups(Immutable.fromJS(action.groups), state);
      newState = newState.mergeIn(['byCohortPath', action.cohortPath], {
        isLoading: false,
        hasLoaded: true,
      });

      return newState;
    }
    case FETCH_COHORT_GROUPS_LISTING_DATA_FAILURE: {
      return state.setIn(
        ['byCohortPath', action.cohortPath, 'isLoading'],
        false
      );
    }
    case PageActionTypes.BLOCKPAGE_DATA_FETCH_SUCCESS:
    case BLOCKPAGE_DATA_LOADED_SUCCESS: {
      return setGroups(Immutable.fromJS(action.userCohortGroups), state);
    }
    default: {
      return state;
    }
  }
}
